/**
 * 数据请求的唯一入口
 */
import game from './game'
import entry from './entry'
import project from './project'
import race from './race'
import schedule from './schedule'
import raceBoard from './raceBoard'
import matchMap from './matchMap'
import drawLot from './drawLot'
import crewNumber from './crewNumber'
import boatLane from './boatLane'
import round from './round'
import raceBoat from './raceBoat'
import result from './result'
import withDrawal from './withDrawal'
import boatTransfer from './boatTransfer'
import medal from './medal'
import starter from './starter'
import sixteenBracket from './sixteenBracket'

export default {
    game,
    entry,
    project,
    race,
    schedule,
    raceBoard,
    matchMap,
    drawLot,
    crewNumber,
    boatLane,
    round,
    raceBoat,
    result,
    withDrawal,
    boatTransfer,
    medal,
    starter,
    sixteenBracket
}